Vue.component('ack-pac-dent', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-pac-dent',
	mixins: [languageMixins],
	created() {},
	mounted() {
		appLog.log('ack-pac-dent mounted');
		//this.setPageIsLoading(false)
	},
	props: ['productLocalJsonUrl'],
	computed: {
		//...Vuex.mapGetters('sliders', ['slidersLists']),
		...Vuex.mapGetters('articles', ['articlesArray']),
		...Vuex.mapGetters('localization', ['countryCode', 'userLanguage']),
		...Vuex.mapGetters('resins', ['selectedPacDentShopifyProduct']),
		...Vuex.mapState('resins', ['selectedPacDentProductId']),
		/*
      lastArticles(){
        let arr = []
        for (let index = 0; index < 3; index++) {
          const element = this.articlesArray[index];
          arr.push(element)
        }
        return arr
      },
      */
		isMobile() {
			return this.$parent.isMobile;
		},
		storeAvailable() {
			let avl = true;
			if (this.countryCode.toUpperCase() == 'US' || this.countryCode.toUpperCase() == 'CA') {
				avl = false;
			}
			return avl;
		},
	},
	data() {
		return {
			pageId: 'pac-dent-page',
			selectedCard: null,
			activeItem: null,
			default_3dps_bundle: 'shop-3dps-6',
			pacDentInfo: {
				title_section: {
					id: 'gid://shopify/Product/6643132235879',
					title: 'resins.main_title',
					subtitle: 'resins.main_subtitle',
					title_img:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Logo_Resize-08.png?v=1705913619',
					description: 'resins.main_description',
					image_desktop:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Top_banner_8e02cd42-3cbe-4366-9150-3da5f0811d45.jpg?v=1756780354',
					image_mobile: null,
					price: 0.0,
					currencyCode: 'NTD',
					currencySymbol: '$',
					learn_more_url: '',
				},
				feature_section: {
					description: null,
					default_img:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA_AI_V4_Orient_Stack___Nest.gif?v=1703654229',
					feature_items: [
						{
							title: 'resins.feature_section.feature_items.item_one.title',
							description: 'resins.feature_section.feature_items.item_one.description',
							link: null,
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Workflow_Scanning.jpg?v=1721711488',
							open: true,
						},
						{
							title: 'resins.feature_section.feature_items.item_two.title',
							description: 'resins.feature_section.feature_items.item_two.description',
							link: null,
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Workflow_1_CAM.jpg?v=1711699977',
							open: false,
						},
						{
							title: 'resins.feature_section.feature_items.item_three.title',
							description: 'resins.feature_section.feature_items.item_three.description',
							link: null,
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Workflow_2_3D_Printing.jpg?v=1711699978',

							open: false,
						},
						{
							title: 'resins.feature_section.feature_items.item_four.title',
							description: 'resins.feature_section.feature_items.item_four.description',
							link: null,
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Workflow_Cleaning_Process.jpg?v=1711699935',
							open: false,
						},
						{
							title: 'resins.feature_section.feature_items.item_five.title',
							description: 'resins.feature_section.feature_items.item_five.description',
							link: null,
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Workflow_5_UV_Curing.jpg?v=1711699978',
							open: false,
						},
						{
							title: 'resins.feature_section.feature_items.item_six.title',
							description: 'resins.feature_section.feature_items.item_six.description',
							link: null,
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Workflow_4_Characterization.jpg?v=1711699978',
							open: false,
						},
						{
							title: 'resins.feature_section.feature_items.item_seven.title',
							description: 'resins.feature_section.feature_items.item_seven.description',
							link: null,
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Workflow_6_Seating.jpg?v=1711699978',
							open: false,
						},
					],
				},
				media_grid_section: {
					title: 'resins.media_grid_section.title',
					media_grid_collection: {
						main_item: {
							title: 'resins.media_grid_section.media_grid_collection.main_item.title',
							description: 'resins.media_grid_section.media_grid_collection.main_item.description',
							img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Successful_Cases_Nelson_Rego.jpg?v=1711699935',
						},
						secondary_item: {
							title: 'resins.media_grid_section.media_grid_collection.tertiary_item_one.title',
							description:
								'resins.media_grid_section.media_grid_collection.tertiary_item_one.description',
							img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Successful_Cases_Gupta.jpg?v=1711699935',
						},
						tertiary_item_one: {
							title: 'resins.media_grid_section.media_grid_collection.secondary_item.title',
							description:
								'resins.media_grid_section.media_grid_collection.secondary_item.description',
							img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Successful_Cases_Jose_Antonio.jpg?v=1711699977',
						},
						tertiary_item_two: {
							title: 'resins.media_grid_section.media_grid_collection.tertiary_item_two.title',
							description:
								'resins.media_grid_section.media_grid_collection.tertiary_item_two.description',
							img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Successful_Cases_Eugene.jpg?v=1711699977',
						},
					},
				},
				video_section: {
					title: 'resins.video_section.title',
					subtitle: null,
					description: 'resins.video_section.description',
					video:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA-AI_V4_Variable_Layer_Thickness.gif?v=1703654229',
				},
				product_menu_section: {
					//Rodin Resins Line
					resins: {
						title: 'Rodin Resins Line',
						menu_items: [
							{
								imageMenu:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Icon_RapidCeram.png?v=1756795381',
								imageLogo:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Card_RapidCeram.png?v=1752741293',
								id: 'rapidCeram',
								productId: '7345430462567',
								link: '#rapidCeram',
							},
							{
								imageMenu:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Icon_EnVision.png?v=1756795382',
								imageLogo:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Card_EnVision.png?v=1752741293',
								id: 'enVision',
								productId: '7345446813799',
								link: '#enVision',
							},
							{
								imageMenu:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Icon_Sculpture_2.0.png?v=1756795381',
								imageLogo:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Card_Sculpture_2.0.png?v=1752741293',
								id: 'sculpture_2',
								productId: '6908625911911',
								link: '#sculpture_2',
							},
							{
								imageMenu:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Icon_Titan.png?v=1756795381',
								imageLogo:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Card_Titan.png?v=1752741293',
								id: 'titan',
								productId: '6908629811303',
								link: '#titan',
							},
							{
								imageMenu:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Icon_Denture_Base_2.0.png?v=1756795381',
								imageLogo:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Card_Denture_Base_2.0.png?v=1752741293',
								id: 'denture_2',
								productId: '6908632727655',
								link: '#denture_2',
							},
							{
								imageMenu:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Icon_Try-In.png?v=1756795382',
								imageLogo:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Card_Try-In.png?v=1752741293',
								id: 'tryIn',
								productId: '7346083889255',
								link: '#tryIn',
							},
							{
								imageMenu:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Icon_Icon_Resin_Cleaner.png?v=1761043978',
								imageLogo: '',
								id: 'resin_cleaner',
								productId: '7412868808807',
								link: '#resin_cleaner',
							},
							// hide product request by memo
							// {
							// 	imageMenu: '',
							// 	imageLogo:
							// 		'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Card_Bite_Tray.png?v=1752741293',
							// 	id: 'biteTray',
							// 	productId: '7346078122087',
							// 	link: '#biteTray',
							// },
							// {
							// 	imageMenu: '',
							// 	imageLogo:
							// 		'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Card_Surgical_Guide_2.0.png?v=1752741293',
							// 	id: 'surgicalGuide_2',
							// 	productId: '7346126717031',
							// 	link: '#surgicalGuide_2',
							// },
							// {
							// 	imageMenu: '',
							// 	imageLogo:
							// 		'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Card_Splint_2.0.png?v=1752741293',
							// 	id: 'splint_2',
							// 	productId: '7346132680807',
							// 	link: '#splint_2',
							// },
							// {
							// 	imageMenu: '',
							// 	imageLogo:
							// 		'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Card_Flexisplint.png?v=1752741293',
							// 	id: 'flexisplint',
							// 	productId: '7346138546279',
							// 	link: '#flexisplint',
							// },
							// {
							// 	imageMenu: '',
							// 	imageLogo:
							// 		'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Card_Castable.png?v=1752741293',
							// 	id: 'castable',
							// 	productId: '7346144051303',
							// 	link: '#castable',
							// },
							// {
							// 	imageMenu: '',
							// 	imageLogo:
							// 		'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Card_Ortho_IBT.png?v=1752741294',
							// 	id: 'orthoIBT',
							// 	productId: '7346150473831',
							// 	link: '#orthoIBT',
							// },
						],
					},
					naturalizations: {
						title: 'Naturalizations Line',
						menu_items: [
							//Naturalization Line
							{
								imageMenu:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Icon_N2-Free_Glaze.png?v=1756795381',
								imageLogo:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Card_Glaze_N2-Free.png?v=1752741293',

								id: 'n2_free_glaze',
								productId: '7211636359271',
								link: '#n2_free_glaze',
							},
							{
								imageMenu:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Icon_Palette_2.0_Kit.png?v=1756795382',
								imageLogo:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Card_Palette_2.0_with_Glaze_N2-Free.png?v=1752741293',
								id: 'naturalizing_kit_2',
								productId: '7211598381159',
								link: '#naturalizing_kit_2',
							},
						],
					},
					bondings: {
						title: 'Bonding Line',
						menu_items: [
							// Bonding Line
							{
								imageMenu: '',
								imageLogo:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Icon_Soft_Reline.png?v=1756795381',
								id: 'softReline',
								productId: '7346306777191',
								link: '#softReline',
							},
							{
								imageMenu:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Icon_Bond_Kit.png?v=1756795381',
								imageLogo:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Card_Bond_Kit.png?v=1752741293',
								id: 'adhesive_kit',
								productId: '6908636790887',
								link: '#adhesive_kit',
							},
							{
								imageMenu:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Icon_Luting_Cement.png?v=1756795381',
								imageLogo:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Card_Luting_Cement.png?v=1752741293',
								id: 'lutingCement',
								productId: '7346161123431',
								link: '#lutingCement',
							},

							// hide product req by memo
							// {
							// 	imageMenu: '',
							// 	imageLogo:
							// 		'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Card_Sensiguard.png?v=1752741293',
							// 	id: 'sensiguard',
							// 	productId: '7346208243815',
							// 	link: '#sensiguard',
							// },
							// {
							// 	imageMenu: '',
							// 	imageLogo:
							// 		'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Card_Rodin_Bond.png?v=1752741293',
							// 	id: 'bond',
							// 	productId: '7346192154727',
							// 	link: '#bond',
							// },
						],
					},
				},
				article_section: {
					articles: [
						{
							title: 'The Future of 3D Printing in Dentistry',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Thumbnail_Lee_Culp.jpg?v=1711699935',
							url: 'https://cdn.ackuretta.com/downloads/pac-dent/Lee%20Culp%20CDT%20Article.pdf',
						},
						{
							title: 'The Benefits of 3D Printing in Dentistry',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Thumbnail_Chonway.jpg?v=1711699978',
							url: 'https://cdn.ackuretta.com/downloads/pac-dent/0723Odowling[5].pdf',
						},
						{
							title: 'The Advantages of 3D Printing in Dentistry',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Thumbnail_O_Dowling.jpg?v=1711699978',
							url: 'https://cdn.ackuretta.com/downloads/pac-dent/IDV19N7_Why_I_Invested_Pacdent_6th.pdf',
						},
					],
				},
				first_image_section: {
					title: 'resins.first_image_section.title',
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Mechanical_Properties_Comparison_f06cfa47-5e5b-4dd7-92ed-6418e6464972.jpg?v=1742183674',
					notes: 'resins.first_image_section.notes',
				},
				second_image_section: {
					title: 'resins.second_image_section.title',
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Vita_Shades_c966d301-9d7c-4efa-9a3e-406742d2df46.jpg?v=1742183674',
				},
			},
		};
	},
	methods: {
		...Vuex.mapActions(['setPageIsLoading']),
		//...Vuex.mapActions('sliders', ['getSlideList'])
		...Vuex.mapActions('resins', ['menuItemClick']),
		...Vuex.mapActions('localization', ['fetchTranslations', 'fetchLocalTranslations']),

		onMainTranslationsLoaded() {},

		onResinMenuItemClick(item) {
			this.menuItemClick(item.productId);
		},
		formatMenuItems(datas) {
			let result = [];
			for (const key in datas) {
				result = [...result, ...datas[key].menu_items];
			}
			return result;
		},
	},
	beforeDestroy() {},
	watch: {
		data1: {
			handler() {},
			deep: false,
		},
	},
});
